import styles from "./ProductDetailsPage.module.css";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokProduct } from "@/storyblok";
import type { BaseSBType } from "@/types/storyblok-compat";
import { StoryblokComponent, type BlokProps } from "@frend-digital/storyblok";

export const ProductDetailsPageBlok = ({ blok, preview }: BlokProps<BlokProduct>) => {
	return (
		<BlokWrap editable={blok} as="div" className={styles.root}>
			{blok.body?.map((blok, index) => (
				<StoryblokComponent
					index={index + 1}
					blok={blok as BaseSBType}
					key={(blok as BaseSBType)._uid}
					preview={preview}
				/>
			))}
		</BlokWrap>
	);
};
